<cerrix-loader [cerrixTab]="tab"></cerrix-loader>

@if (!tab.showLoader) {
    <div
        menuSystem
        [cerrixTab]="tab"
        class="details"
        (changeEvent)="handleMenuItemClick($event)"
        data-uiid="audit-finding-detail-main"
    >
        <div class="detail-page-action-bar">
            @if (permissions.canEdit || permissions.canEditManagementResponse) {
                <button data-uiid="btn-audit-finding-save" class="btn btn-cerrix" (click)="save()">
                    <i class="fas fa-save"></i>
                    <span class="d-none d-lg-inline">{{
                        "detail.saveFinding" | t
                    }}</span>
                </button>
            }

            @if (model.id > 0) {
                <span class="date-edited">
                    Last save: {{ model.modifiedOn | dateTimeFormat }}
                </span>
            }

            @if (workflowStatusKey) {
                <div class="workflow-area">
                    <span class="workflow-description">
                        {{ "detail.workflowStatusLabel" | t }}
                        <b>{{ workflowStatusKey | t }}</b>
                    </span>
                    <span>
                        @if (acceptButtonKey) {
                            <button
                                class="btn btn-success"
                                type="button"
                                (click)="acceptButtonClick()"
                                data-uiid="audit-finding-workflow-accept-button"
                            >
                                {{ acceptButtonKey | t }}
                            </button>
                        }
                        @if (rejectButtonKey) {
                            <button
                                class="btn btn-danger"
                                type="button"
                                (click)="rejectButtonClick()"
                                data-uiid="audit-finding-workflow-reject-button"
                            >
                                {{ rejectButtonKey | t }}
                            </button>
                        }
                    </span>
                </div>
            }
        </div>

        <div
            class="screens"
            menuItemId="menuItemAuditFinding"
            [attr.name]="'detail.menuAuditFinding' | t"
            menuicon="far fa-radar"
            menusystemsubmenu
        >
            <div
                [attr.name]="'detail.menuDetails' | t"
                menuItemId="finding-detail"
                menuicon="fas fa-info-circle"
                menusystemitem
            >
                <audit-finding-detail-main
                    [parentFormGroup]="formGroup"
                    [findingModel]="model"
                    [permissions]="permissions"
                ></audit-finding-detail-main>

                @if (model && model.id > 0) {
                    <audit-finding-detail-audit-info [findingGuid]="model.guid">
                    </audit-finding-detail-audit-info>
                }

                @if (tableConfig && model && model.findingReportGuid) {
                    <generic-list-manager [config]="tableConfig"></generic-list-manager>
                }

                @if (tableConfig && model && !model.findingReportGuid) {
                    <div class="detail-page-card">
                        <div class="detail-page-card-title">
                            {{ "detail.measuresOfImprovementsTitle" | t }}
                        </div>
                        <div class="detail-page-card-body padded form-group-styling">
                            <div class="row">
                                {{ "detail.createFindingsReportFirst" | t }}
                            </div>
                        </div>
                    </div>
                }
            </div>
            @if (permissions.canViewHistory) {
                <div
                    [attr.name]="'detail.menuHistory' | t"
                    menuicon="fas fa-history"
                    menuItemId="history"
                    menusystemitem
                >
                    <app-history-overview
                        [Id]="model.guid"
                        [historyDataService]="_ds"
                        #historyDetailOverviewComponent
                    ></app-history-overview>
                </div>
            }

            @if (permissions.canDelete) {
                <div
                    menuItemId="menuItemOptions"
                    [attr.name]="'detail.menuOptions' | t"
                    menuicon="fas fa-check-double"
                    menusystemitem
                >
                    <detail-options
                        moduleName="audit finding"
                        [objectName]="'audit finding'"
                        [allowDelete]="true"
                        (onDelete)="delete()"
                    >
                    </detail-options>
                </div>
            }
        </div>
    </div>
}
